/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { TextField, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { LoadingButton } from '@mui/lab';

import useSnackbar from 'hooks/useSnackbar';
import { Close } from '@mui/icons-material';
import usePermission from 'hooks/usePermission';
import { useEActivitySignMutation, useLazyGetActivityTimeDetailsQuery } from 'store/services/activitySetup';
import useAuth from 'hooks/useAuth';

function SignModal({ open, handleClose, id, handleUpdate, onSuccess, restrictPasswordAutoPopulate = false }) {
    const { user } = useAuth();
    const [pin, setPin] = useState('');
    const { notify } = useSnackbar();
    const [eSign, { isLoading }] = useEActivitySignMutation();

    const [triggerActivityTimeDetails, { data: details, isLoading: isDetailLoading, isFetching: isDetailFetching }] =
        useLazyGetActivityTimeDetailsQuery();

    useEffect(() => {
        if (restrictPasswordAutoPopulate && open) {
            setPin('');
        }
    }, [open, restrictPasswordAutoPopulate]);

    const handleDialogClose = () => {
        if (restrictPasswordAutoPopulate) {
            setPin('');
        }
        handleClose();
    };

    const handleSign = async () => {
        if (!pin) {
            notify({
                message: 'Enter Password',
                severity: 'error'
            });
            return;
        }
        try {
            const response = await handleUpdate();
            if (!response) {
                return;
            } else {
                const payload = {
                    id: id,
                    client_id: user?.client_id,
                    password: pin
                };
                console.log('payload:', payload);
                const res = await eSign(payload).unwrap();

                handleDialogClose();

                await triggerActivityTimeDetails({
                    client_id: user?.client_id,
                    id: id
                });
                notify({
                    message: res?.message,
                    severity: 'success'
                });
                if (onSuccess) {
                    await onSuccess();
                }
            }
        } catch (error) {
            console.log('error:', error);
            notify({
                message: error.data?.message || 'Something Went Wrong',
                severity: 'error'
            });
        }
    };

    return (
        <>
            <Dialog open={open} onClose={handleDialogClose}>
                <IconButton onClick={handleDialogClose} sx={{ position: 'absolute', top: 0, right: 0, m: 1 }}>
                    <Close />
                </IconButton>
                <DialogTitle>E-Sign</DialogTitle>
                {restrictPasswordAutoPopulate ? (
                    <form
                        autoComplete="off"
                        noValidate
                        onSubmit={(event) => {
                            event.preventDefault();
                            handleSign();
                        }}
                    >
                        <DialogContent
                            sx={{
                                p: 2,
                                width: '100vw',
                                maxWidth: 400
                            }}
                        >
                            <input
                                type="text"
                                name="username"
                                autoComplete="username"
                                style={{
                                    position: 'absolute',
                                    left: '-9999px',
                                    width: '1px',
                                    height: '1px',
                                    opacity: 0
                                }}
                                tabIndex={-1}
                                aria-hidden="true"
                            />
                            <TextField
                                sx={{ mt: 1 }}
                                id="time-sheet-esign-password"
                                name="time-sheet-esign-password"
                                label="Password"
                                type="password"
                                fullWidth
                                variant="outlined"
                                autoComplete="new-password"
                                inputProps={{
                                    autoComplete: 'new-password',
                                    'data-form-type': 'other',
                                    'data-lpignore': 'true',
                                    'data-1p-ignore': 'true'
                                }}
                                value={pin}
                                onChange={(e) => setPin(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <LoadingButton loading={isLoading} variant="contained" type="submit">
                                Sign
                            </LoadingButton>
                        </DialogActions>
                    </form>
                ) : (
                    <>
                        <DialogContent
                            sx={{
                                p: 2,
                                width: '100vw',
                                maxWidth: 400
                            }}
                        >
                            <TextField
                                sx={{ mt: 1 }}
                                label="Password"
                                type="password"
                                fullWidth
                                variant="outlined"
                                autoComplete="off"
                                value={pin}
                                onChange={(e) => setPin(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <LoadingButton loading={isLoading} variant="contained" onClick={handleSign}>
                                Sign
                            </LoadingButton>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* <NoBillingList setBulkList={setBulkList} bulkList={bulkList} /> */}
        </>
    );
}

export default SignModal;
